import { createSlice } from '@reduxjs/toolkit';

const providerAppointments = createSlice({
  name: 'providerAppointments',
  initialState: {
    isLoading: false,
    appointments: {
      active: [],
      past: [],
    },
  },
  reducers: {
    appointmentsRequest(state) {
      state.isLoading = true;
    },
    appointmentsSuccess(state, { payload }) {
      state.isLoading = false;
      state.appointments = payload.data;
    },
    appointmentsFailure(state) {
      state.isLoading = false;
    },
    updateSingleAppointment(state, { payload }) {
      const updatedAppointment = payload.data;
      const udpatedActiveAppointments = state.appointments.active.map(
        (appt) => {
          if (appt.uuid === updatedAppointment.uuid) return updatedAppointment;
          return appt;
        }
      );

      state.appointments.active = udpatedActiveAppointments;
    },
  },
});

const { actions, reducer } = providerAppointments;

export const {
  appointmentsRequest,
  appointmentsSuccess,
  appointmentsFailure,
  updateSingleAppointment,
} = actions;

export default reducer;
